export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/GA-96c760085e2868e4a77f21761e7a6371.png";